/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * CDVX component information
 */
export interface CdvxComponentInfo { 
    /**
     * Version of the CDVX image
     */
    version?: string;
    /**
     * Cloud provider where the CDVX is deployed
     */
    cloudProvider?: string;
    /**
     * Availability zone of the CDVX
     */
    availabilityZone?: string;
    /**
     * Type of CDVX instance
     */
    cloudDvxType?: string;
    /**
     * Capacity of the CDVX instance
     */
    capacity?: string;
    /**
     * Organization identifier
     */
    orgId?: string;
    /**
     * Associated IRR instance identifier
     */
    irrId?: string;
}

